/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityBackfillRequestDto } from '../models/EntityBackfillRequestDto';
import type { EntityBackfillResultDto } from '../models/EntityBackfillResultDto';
import type { EntityBackfillTableDto } from '../models/EntityBackfillTableDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EntityBackfillService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns EntityBackfillTableDto OK
     * @throws ApiError
     */
    public getApiHousingEntityBackfillTables(): CancelablePromise<Array<EntityBackfillTableDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/EntityBackfill/Tables',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns EntityBackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingEntityBackfillBackfill(
        requestBody?: EntityBackfillRequestDto,
    ): CancelablePromise<EntityBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/EntityBackfill/Backfill',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
